import type { IMap } from '@ikegps/core-shared';
import { observable, type ObservableMap } from 'mobx';

export class ObservableIMap<T> implements IMap<T> {
	_values: ObservableMap<string, T> = observable.map<string, T>({}, { deep: false });

	get(key: string): T {
		return this._values.get(key);
	}
	set(key: string, value: T) {
		this._values.set(key, value);
	}
	has(key: string): boolean {
		return this._values.has(key);
	}
	keys(): string[] {
		return Array.from(this._values.keys());
	}
	values(): T[] {
		return Array.from(this._values.values());
	}
	clear() {
		this._values.clear();
	}
	delete(key: string) {
		this._values.delete(key);
	}
	get size(): number {
		return this._values.size;
	}
}
